export default __webpack_public_path__ + "static/media/toast-close.f4cc25dd.svg";